module.exports = __webpack_public_path__ + "img/norte-light-preview.0da64e65.png";